import React from "react";

import { PeopleCard, PeopleList } from "@caelor/ui";

import { OVERVIEW_DUMMY_DATA } from "./data";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import {
  PeopleCardOverviewContainer,
  PeopleContainer,
  PeopleOverviewContainer,
  PeopleTitle,
  PeopleWrapper,
} from "./styles";
import { MACRO_KEY } from "../../../../../defaults";
import { useNewStartersStore } from "../../../../../../stores/use-new-starters-store";
import { DEFAULT_ACCENT_COLOR } from "../../../../../../features/people/defaults";
import { useStyleguideColors } from "../../../../../../hooks/use-styleguide-colors";
import {
  buildTemplate,
  NEW_STARTERS_TEMPLATES,
} from "./new-starters-templates";

const CardRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "row", gap: 8 }}>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        emoji="🚀"
        subtitle="Full Stack Developer"
        label="Jun 1"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 166 }}>
      <PeopleCard
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Head of Engineering"
        label="May 15"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const ListRender = ({ accent, borderRadius }) => (
  <div style={{ display: "flex", flexFlow: "column", gap: 8 }}>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Angelica Lorens"
        avatarUrl="/img/peopleList.svg"
        emoji="🚀"
        subtitle="Full Stack Developer"
        label="Jun 1"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Liam Brooks"
        avatarUrl="/img/peopleCard.svg"
        subtitle="Head of Engineering"
        label="May 15"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
    <div style={{ width: 475 }}>
      <PeopleList
        name="Ava Turner"
        avatarUrl="/img/peopleList.svg"
        subtitle="Operations Coordinator"
        label="May 15"
        accentColor={accent}
        borderRadius={borderRadius}
        isTemplate
      />
    </div>
  </div>
);

const VIEWS = {
  card: { label: "Card", View: CardRender },
  list: { label: "List", View: ListRender },
};

export const OverviewTemplates = () => {
  const { setMacro, setDrawers, colorPalette, styleguideSetup } =
    useOpticsStore((state) => ({
      setMacro: state.setMacro,
      setDrawers: state.setDrawers,
      colorPalette: state.colorPalette,
      styleguideSetup: state.styleguideSetup,
    }));

  const setData = useNewStartersStore((state) => state.setData);

  const borderRadius = styleguideSetup?.cornerRadius || 3;

  return (
    <PeopleOverviewContainer
      onClick={() => {
        setMacro({ key: MACRO_KEY.NEW_STARTERS });
        setData({ ...buildTemplate("card", borderRadius) });
        setDrawers({ templates: false, settings: true });
      }}
    >
      {OVERVIEW_DUMMY_DATA.map((person) => (
        <PeopleCardOverviewContainer>
          <PeopleCard
            name={person.name}
            avatarUrl={person.avatarUrl}
            subtitle={person.subtitle}
            label={person.label}
            emoji={person.emoji}
            accentColor={colorPalette?.accent}
            borderRadius={borderRadius}
          />
        </PeopleCardOverviewContainer>
      ))}
    </PeopleOverviewContainer>
  );
};

const NewStartersTemplates = () => {
  const { setData, data } = useNewStartersStore((state) => ({
    setData: state.setData,
    data: state.data,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  const color =
    data?.accentColor || styleguideColors?.accent || DEFAULT_ACCENT_COLOR;

  const borderRadius = data?.borderRadius || styleguideSetup?.cornerRadius || 3;

  const buildData = (template, value) => {
    if (Object.keys(data || {}).length) {
      return {
        ...data,
        view: value.view,
      };
    }

    return {
      ...template,
      ...value,
    };
  };

  return (
    <PeopleContainer>
      {NEW_STARTERS_TEMPLATES.map((template) => {
        const { label, View } = VIEWS[template.view];
        return (
          <PeopleWrapper
            key={template.id}
            onClick={() => {
              setData({
                ...buildData(template, {
                  accentColor: color,
                  borderRadius,
                  view: template.view,
                }),
              });
              setDrawers({ templates: false, settings: true });
            }}
          >
            <PeopleTitle>{label}</PeopleTitle>
            <View accent={color} borderRadius={borderRadius} />
          </PeopleWrapper>
        );
      })}
    </PeopleContainer>
  );
};

export default NewStartersTemplates;
